import { requestFlat } from '../constants/requestFlat';
import { flatRequestColorsMap } from '../constants/stagesColorMaps';

const useRequestsCount = (requests = []) => {
  const countRequestMap = new Map([
    [
      'sumNew',
      {
        value: 'Новая',
        color: flatRequestColorsMap.get(requestFlat.NEW_REQUEST),
        count: 0,
      },
    ],
    [
      'sumProgress',
      {
        value: 'В работе',
        color: flatRequestColorsMap.get(requestFlat.WORK_REQUEST),
        count: 0,
      },
    ],
    [
      'sumCompleted',
      {
        value: 'Выполнена',
        color: flatRequestColorsMap.get(requestFlat.COMPLETED_REQUEST),
        count: 0,
      },
    ],
    [
      'sumClosed',
      {
        value: 'Закрыта',
        color: flatRequestColorsMap.get(requestFlat.CLOSE_REQUEST),
        count: 0,
      },
    ],
  ]);

  requests.forEach((request) => {
    switch (request.statusId) {
      case 1:
        return countRequestMap.set('sumNew', {
          ...countRequestMap.get('sumNew'),
          count: countRequestMap.get('sumNew').count + 1,
        });
      case 2:
        return countRequestMap.set('sumProgress', {
          ...countRequestMap.get('sumProgress'),
          count: countRequestMap.get('sumProgress').count + 1,
        });
      case 3:
        return countRequestMap.set('sumClosed', {
          ...countRequestMap.get('sumClosed'),
          count: countRequestMap.get('sumClosed').count + 1,
        });
      case 5:
        return countRequestMap.set('sumCompleted', {
          ...countRequestMap.get('sumCompleted'),
          count: countRequestMap.get('sumCompleted').count + 1,
        });
      default:
        return;
    }
  });

  return Array.from(countRequestMap.values());
};
export default useRequestsCount;
